import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SuperUserGuard } from './common/guard/super-user-guard';

export const routes: Routes = [
  {
    path: 'newpools',
    loadChildren: () =>
      import('@new/pools/pools.module').then(m => m.PoolsModule)
  },
  {
    path: 'newadmin',
    loadChildren: () =>
      import('@new/admin/admin.module').then(m => m.AdminModule),
    canActivate: [SuperUserGuard]
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('@new/profile/profile.module').then(m => m.ProfileModule)
  },
  {
    // PROTOTYPE — throwaway, guard-free. Demo harness for the new
    // form-components. Accessible at /prototype-form-components.
    path: 'prototype-form-components',
    loadComponent: () =>
      import(
        './__prototype__/form-components-demo/form-components-demo.component'
      ).then(m => m.FormComponentsDemoComponent)
  },
  // FIXME: temporary exceptions, remove once we have the second isulated angular app
  {
    path: '**',
    loadComponent: () =>
      import('@new/common/not-found-page/not-found-page.component').then(
        m => m.NotFoundPageComponent
      )
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'disabled',
      // "computed" should fix issues with navigation canceling when the "unsaved changes" dialog is shown after the back button is pressed
      canceledNavigationResolution: 'computed'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
